import { PerspectiveCamera, Scene, WebGLRenderer, sRGBEncoding } from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
const orbitControlsParams = {
    cameraDistanceMin: 1.00012,
    cameraDistanceMax: 2.5,
    pan: false,
    damping: true
};
const cameraParams = {
    fov: 75,
    near: 0.00001,
    far: 4
};
export default class ThreeContext {
    isAnimationLoopActive;
    canvas;
    renderer;
    scene;
    camera;
    controls;
    constructor(canvasSelector) {
        this.isAnimationLoopActive = false;
        this.canvas = document.querySelector(canvasSelector);
        this.camera = new PerspectiveCamera(cameraParams.fov, this.canvas.clientWidth / this.canvas.clientHeight, cameraParams.near, cameraParams.far);
        this.scene = new Scene();
        this.renderer = new WebGLRenderer({
            canvas: this.canvas,
            antialias: true
        });
        this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight, false);
        this.renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
        this.renderer.outputEncoding = sRGBEncoding;
        this.controls = new OrbitControls(this.camera, this.canvas);
        this.controls.enableDamping = orbitControlsParams.damping;
        this.controls.minDistance = orbitControlsParams.cameraDistanceMin;
        this.controls.maxDistance = orbitControlsParams.cameraDistanceMax;
        this.controls.enablePan = orbitControlsParams.pan;
        this.scene.add(this.camera);
    }
    contextDestroy() {
        this.renderer.dispose();
    }
    getCameraPositionAsParam() {
        const cameraDistanceFromOrigin = this.camera.position.length();
        return (cameraDistanceFromOrigin - orbitControlsParams.cameraDistanceMin) / (orbitControlsParams.cameraDistanceMax - orbitControlsParams.cameraDistanceMin);
    }
    getCameraPosition() {
        const cameraPosition = this.camera.position;
        return cameraPosition;
    }
    setCameraPositionParam(λCamera) {
        let λ = λCamera;
        λ = Math.min(λ, 1);
        λ = Math.max(0, λ);
        const newLength = orbitControlsParams.cameraDistanceMin * (1 - λ) + orbitControlsParams.cameraDistanceMax * λ;
        const { x, y, z } = this.getCameraPosition().normalize();
        return this.setCameraPosition(x * newLength, y * newLength, z * newLength);
    }
    setColour(colour) {
        this.renderer.setClearColor(colour);
    }
    setCameraPosition(x, y, z) {
        this.camera.position.x = x;
        this.camera.position.y = y;
        this.camera.position.z = z;
    }
    updateSize() {
        this.camera.aspect = this.canvas.clientWidth / this.canvas.clientHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight, false);
        this.renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    }
    add(...objects) {
        this.scene.add(...objects);
    }
    remove(...objects) {
        this.scene.remove(...objects);
    }
    getClientWidth() {
        return this.canvas.clientWidth;
    }
    getClientHeight() {
        return this.canvas.clientHeight;
    }
    getCamera() {
        return this.camera;
    }
    startAnimationLoop(update) {
        this.isAnimationLoopActive = true;
        let frame = () => {
            const λ = this.getCameraPositionAsParam();
            update(λ);
            this.controls.rotateSpeed = λ;
            this.controls.zoomSpeed = λ;
            this.controls.update();
            this.renderer.render(this.scene, this.camera);
            if (!this.isAnimationLoopActive) {
                return;
            }
            window.requestAnimationFrame(frame);
        };
        frame();
    }
    stopAnimationLoop() {
        this.isAnimationLoopActive = false;
    }
}
